import {Injectable} from '@angular/core';

@Injectable()
export class ArraysService {
  /**
   * Groups an array of objects by a specific property.
   * @param array - The array of objects to group.
   * @param key - The property to group by.
   * @returns An object where the keys are the property values and the values are arrays of objects.
   */
  public groupBy<T, K extends keyof T>(
    array: T[],
    key: K
  ): Record<string, T[]> {
    return array.reduce((accumulator, current) => {
      const groupKey = String(current[key]); // Explicitly convert the key to a string
      if (!accumulator[groupKey]) {
        accumulator[groupKey] = [];
      }
      accumulator[groupKey].push(current);
      return accumulator;
    }, {} as Record<string, T[]>);
  }
}
